import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom"
import getStringsBasedLang from "../strings/get_strings"

export const showToastError = (errorMessage) => {
  toast(errorMessage, { type: "error" });
};
export const showToastSuccess = (errorMessage) => {
  toast(errorMessage, { type: "success" });
};
export const showToastWarning = (errorMessage) => {
  toast(errorMessage, { type: "warning" });
};

const UseErrorHandling = () => {
  let timeoutCount = 0
  const navigate = useNavigate();
  const location = useLocation()

  const InvalidTokenStrategy = (errorMessage) => {
    showToastError(errorMessage);
    setTimeout(() => {
      navigate("/login");
    }, 2000);
  };

  const AuthorizationFailedStrategy = (errorMessage) => {
    showToastError(errorMessage);
    localStorage.removeItem('userInfo')
    localStorage.removeItem('info')
    setTimeout(() => {
      navigate("/login");
    }, 2000);
  };

  const UnavailableServiceStrategy = (errorMessage) => {
    // showToastError(errorMessage);
    navigate("/out_service")
  };
  const errorHandlerKiosk = {
    99: (errorData) => AuthorizationFailedStrategy(errorData),
    118: (errorData) => InvalidTokenStrategy(errorData),
    154: (errorData) => UnavailableServiceStrategy(errorData),
  };


  const showError = (statusCode, errorMessage) => {
    if (!(statusCode in errorHandlerKiosk)) {
      showToastError(errorMessage);
    }
    else if (statusCode in errorHandlerKiosk) {
      errorHandlerKiosk[statusCode](errorMessage)
    }
  };

  const handleErrorApi = (Result) => {
    const { error_code: statusCodeResponse, status: statusCodeError, error_desc: errorMessageResponse, data: errorMessageError } = Result;
    const errorMessageRes = getStringsBasedLang(`error_${statusCodeResponse}`) ? getStringsBasedLang(`error_${statusCodeResponse}`) : errorMessageResponse;
    if (statusCodeResponse) showError(statusCodeResponse, errorMessageRes);
    if (statusCodeError) showError(statusCodeError, errorMessageError);
  };

  return handleErrorApi;
};

export default UseErrorHandling;
